import React from 'react';

const Help = () => (
	<p>Hi, i am here to help you!</p>
);

export default Help;
